export default {
  APP_MAIN_MENU: 'app_main_menu',
  EDITOR_HEADER: 'editor_header',
  CUSTOMIZE_COLORS: 'customize_colors',
  CUSTOMIZE_FONTS: 'customize_fonts',
  CUSTOMIZE_COLORS_FROM_SETTINGS: 'customize_colors_from_settings',
  BACK_FROM_CUSTOM_PALETTE: 'back_from_custom_palette',
  BACK_FROM_COLOR_PALETTE_SETTINGS: 'back_from_color_palette_settings',
  SWITCH_BLOCK_LAYOUT: 'switch_block_layout',
};
